import { AgentLiteModel, useGetAgents } from 'api-hooks/agent';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import useGenerateSelectProps from 'hooks/use-generate-select-props';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

function transformer(item: AgentLiteModel): Option {
  return {
    id: item.id,
    label: item.name,
  };
}

export interface AgentFilterSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
  required?: boolean;
}

export default function AgentFilterSelectInput(
  props: AgentFilterSelectInputProps,
) {
  const { t } = useTranslation();
  const {
    label = t('common:agent'),
    placeholder = t('common:select_agent'),
    value,
    onSelected,
    required,
  } = props;

  const query = useGetAgents({
    params: {
      limit: -1,
    },
  });

  const { options, value: _value } = useGenerateSelectProps({
    query,
    transformer,
    value,
  });

  const { pathname } = useRouter();

  const _required = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.AgentMutationReport:
        return true;
      default:
        return required;
    }
  }, [pathname, required]);

  return (
    <CustomFormControl
      label={label}
      noMargin={props.noMargin}
      required={_required}
    >
      <Select
        type="select"
        placeholder={placeholder}
        options={options}
        value={_value}
        onChange={(params: any) => {
          onSelected?.(params?.option?.id);
        }}
        required={_required}
      />
    </CustomFormControl>
  );
}
